import axios from '../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/admin/ARole/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/admin/ARole/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/admin/ARole/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/admin/ARole/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/admin/ARole/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/admin/ARole/delete",{
        params: {
            ids:params
        }
    } )
}


function GET_JURISDICTION(params) {
    return  axios.get("/admin/ARole/authorize",{
        params: {
            id:params
        }
    } )
}
function SUBMIT_JURISDICTION(params) {
    return  axios.post("/admin/ARole/authorizePost",{...params}  )
}

//管理员
function GET_ADMINISTRATOR() {
    return axios.get("/admin/AUser/index" )
}
function GET_FORMDATA() {
    return axios.get("/admin/AUser/add" )
}

function SUBMIT_ADD_ADMINISTRATOR(params) {
    return axios.post("/admin/AUser/addPost",{...params} )
}
function GET_FORMDATA_ADMINISTRATOR(params) {
    return axios.post("/admin/AUser/add",{...params} )
}
function GET_EDIT_FORM_ADMINISTRATOR(params) {
    return  axios.get("/admin/AUser/edit",{
        params: {
            id:params
        }
    } )
}


function CHANG_STATUS_ADMINISTRATOR (params) {
    return  axios.post("/admin/AUser/statusEdit",{status:params} )
}

function SUBMIT_EDIT_ADMINISTRATOR(params) {
    return axios.post("/admin/AUser/editPost",{...params} )
}
function GET_EDIT_ADMINISTRATOR(params) {
    return  axios.get("/admin/AUser/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    GET_JURISDICTION,
    SUBMIT_JURISDICTION,
    DELE,

    //管理员
    GET_ADMINISTRATOR,
    GET_FORMDATA,
    SUBMIT_ADD_ADMINISTRATOR,
    SUBMIT_EDIT_ADMINISTRATOR,
    GET_FORMDATA_ADMINISTRATOR,
    GET_EDIT_FORM_ADMINISTRATOR,
    GET_EDIT_ADMINISTRATOR,
    CHANG_STATUS_ADMINISTRATOR
};